import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTheme } from "@emotion/react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, IconButton, useMediaQuery } from "@mui/material";
import './carouselComponent.css';

function NextArrow(props) {
    const { onClick } = props;

    return (
        <Box
            style={{
                position: 'absolute',
                right: -50,
                top: '50%',
                display: 'none'
            }}
        >
            <IconButton 
                aria-label="next" 
                size="small"
                onClick={onClick}
            >
                <ArrowForwardIosIcon />
            </IconButton>
        </Box>
    );
}

function PrevArrow(props) {
    const { onClick } = props;

    return (
        <Box
            style={{
                position: 'absolute',
                left: -50,
                top: '50%',
                display: 'none'
            }}
        >
            <IconButton 
                aria-label="next" 
                size="small"
                onClick={onClick}
            >
                <ArrowBackIosIcon 
                    sx={{
                        pl: 0.5
                    }}
                />
            </IconButton>
        </Box>
    );
}

function CarouselComponent({
    list
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    var settings = {
        speed: 500,
        slidesToShow: isMobile ? 1 : 2,
        slidesToScroll: 1,
        pauseOnHover: true,
        autoplay: true,
        dots: true,
        infinite: true,
        lazyLoad: true,
        swipeToSlide: true,
        focusOnSelect: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1536,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div 
            className="slider-container" 
            style={{ width: '100%' }}
        >
            <Slider {...settings}>
                {
                    list.map((item, index) => {
                        return <div 
                            key={index}
                        >
                            {item}
                        </div>
                    })
                }
            </Slider>
        </div>
    );
}

export default CarouselComponent;